module.exports = "<div #chart_container id=\"chart_container\"></div>\n\n\n"